import { AUTH_ERROR_EVENT } from 'src/static/consts/events';
export const createAuthError = () => (new Event(AUTH_ERROR_EVENT, { bubbles: true }))